import React from "react";
import CameraView from "../../components/CameraView/CameraView";
import { LiveElevatorViewData } from "./LiveView360";

type CameraSidePanelViewProps = {
  elevator: LiveElevatorViewData | null;
  onClose: () => void;
};

export default function CameraSidePanelView({ elevator, onClose }: CameraSidePanelViewProps) {
  if (!elevator) return null;

  return (
    <div className="fixed right-0 top-0 h-full w-[500px] bg-slate-800/95 backdrop-blur-sm shadow-2xl shadow-black/20 border-l border-slate-700/50 transform transition-transform duration-300 flex flex-col z-[200]">
      <div className="p-6 border-b border-slate-700/50 flex justify-between items-center">
        <h3 className="text-lg font-semibold text-white">
          Live Camera Feed - {elevator.floor} #{elevator.apiDeviceId}
        </h3>
        <button
          onClick={onClose}
          className="p-2 hover:bg-slate-700 rounded-lg transition-colors text-white text-2xl"
        >
          ×
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-6">
        <CameraView
          deviceId={elevator.apiDeviceId}
          cameraIp={elevator.cameraUrl}
        />
      </div>
    </div>
  );
}